import {DataSource} from '@angular/cdk/collections';
import {Observable, of, share, Subject, takeUntil} from 'rxjs';
import {map, switchMap} from 'rxjs/operators';
import {Page, PageRequest, PageSort} from '../services/model';


export type PaginatedData<T, Q> = (pageable: PageRequest<T>, query?: Q) => Observable<Page<T>>

export class PageableDatasource<T, Q> implements DataSource<T> {

  public page$: Observable<Page<T>>;
  protected destroy$: Subject<boolean> = new Subject();

  constructor(private endpoint: PaginatedData<T, Q>, public pageSize: number, params: Observable<DatasourceParams<T, Q>> = of({page: 0})) {
    this.page$ = params.pipe(
      takeUntil(this.destroy$),
      switchMap((params) =>
        this.endpoint({page: params.page, sort: params.sort, size: this.pageSize}, params.filter)),
      share()
    );
  }

  connect(): Observable<T[]> {
    return this.page$.pipe(takeUntil(this.destroy$), map(page => page.content));
  }

  disconnect(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

}

export interface DatasourceParams<T, Q> {
  page: number;
  sort?: PageSort<T>;
  filter?: Q;
}
